/*eslint-disable react/jsx-key */
import React, { Component } from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  YAxis,
  XAxis,
  LabelList,
  Legend,
  Rectangle,
} from 'recharts';

import Table from '../../../../components/Table';
import Icon from '../../../../components/Icon';

import './styles.css';
import {
  ChartContainer,
  ChartTitle,
  LegendContainer,
  DataKeyContainer,
  ChartHeaderContainer,
  Row,
  Col,
} from './styles';

const CustomBar = props => {
  const { fill, index } = props;
  return <Rectangle {...props} fill={index === 0 ? '#263465' : fill} />;
};
export default class DriverDashboard extends Component {
  renderTotalDischargesLabel = props => {
    const { x, y, width, fill, value } = props;

    return (
      <g>
        <text
          x={x + width / 2}
          fontSize={20}
          fontWeight="bold"
          position="top"
          y={y ? y - 28 : 250}
          fill={fill}
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {value}
        </text>
      </g>
    );
  };

  renderTextLabel = props => {
    const { x, y, width, fill } = props;

    return (
      <g>
        <text
          x={x + width / 2}
          fontSize={12}
          position="top"
          y={y ? y - 12 : 265}
          fill={fill}
          textAnchor="middle"
          dominantBaseline="middle"
        >
          Baixas
        </text>
      </g>
    );
  };

  renderCustomLegend = () => {
    const bestThen = this.getBestTen();
    return (
      <LegendContainer>
        {bestThen.map(({ name }) => (
          <DataKeyContainer backgroundColor="white">
            {name.trim().toLowerCase()}
          </DataKeyContainer>
        ))}
      </LegendContainer>
    );
  };

  getBestTen = () => {
    const { data } = this.props;
    if (data.length > 10) return data.slice(0, 10);
    return data;
  };

  renderActionsIcon = () => (
    <Icon className="DriverDashboard__icon" name="eye-open" />
  );

  render() {
    const { data, isFetching } = this.props;

    return (
      <div>
        {isFetching ? null : (
          <div>
            <div style={{ padding: 16 }}>
              <Row>
                <Col md12>
                  <ChartContainer>
                    <ChartHeaderContainer>
                      <ChartTitle>Ranking de Motoristas</ChartTitle>
                    </ChartHeaderContainer>
                    <div
                      style={{
                        width: '100%',
                        height: 350,
                      }}
                    >
                      <div style={{ height: '100%', width: '100%' }}>
                        <ResponsiveContainer height="100%">
                          <BarChart
                            data={this.getBestTen()}
                            margin={{
                              top: 50,
                              right: 50,
                              left: 50,
                              bottom: 0,
                            }}
                          >
                            <YAxis hide domain={[0, 'dataMax + 50']} />
                            <XAxis tickLine={false} />
                            <Legend
                              content={this.renderCustomLegend}
                              dataKey="name"
                              wrapperStyle={{
                                bottom: 20,
                              }}
                            />
                            <Bar
                              shape={CustomBar}
                              dataKey="discharges"
                              fill="#2580AC"
                              radius={[4, 4, 0, 0]}
                              barSize={64}
                            >
                              <LabelList
                                dataKey="discharges"
                                fontSize={20}
                                fontWeight="bold"
                                position="top"
                                fill="#263465"
                                content={this.renderTotalDischargesLabel}
                              />
                              <LabelList
                                dataKey="discharges"
                                fontSize={12}
                                position="top"
                                fill="#828282"
                                content={this.renderTextLabel}
                              />
                            </Bar>
                          </BarChart>
                        </ResponsiveContainer>
                      </div>
                    </div>
                  </ChartContainer>
                </Col>
              </Row>
            </div>
          </div>
        )}
        <Table
          onRowClick={this._onRowClick}
          className="ManifestsInTransit__table"
          isFetching={false}
          wrapCells
          headers={[
            {
              title: '*',
              highlighted: true,
            },
            {
              title: 'Motorista',
              highlighted: true,
            },
            {
              title: 'Placas',
              highlighted: true,
              alignment: 'center',
            },
            {
              title: 'Manifestos',
              highlighted: true,
              alignment: 'center',
            },
            {
              title: 'Notas',
              highlighted: true,
              alignment: 'center',
            },
            {
              title: 'Baixas',
              highlighted: true,
              alignment: 'center',
            },
            {
              title: this.renderActionsIcon(),
              highlighted: true,
              alignment: 'center',
            },
          ]}
          data={data}
        />
      </div>
    );
  }
}
